// TODO: These should be removed once they're exported via the types npm packages by BE devs

export enum AddressType {
  BILLING = 'BILLING',
  DELIVERY = 'DELIVERY',
  OTHER = '',
}

export type Address = {
  line1: string
  line2?: string
  city: string
  postcode: string
  state?: string
  country: string
  type: AddressType
}

export type MemberDetails = {
  id: number
  mvneId: string
  title: string
  originalMemberName: string
  memberName: string
  email: string
  firstName: string
  lastName: string
  alternativePhoneNumber: string
  hasActiveSim: boolean
  tcVersion: number
  birthDate: string
  memberSince: string
  notifyPromotions: boolean
  marketingOptIn: boolean
  marketingPrefsServicePlus: boolean
  marketingPrefsProducts: boolean
  marketingPrefs3PartiesInternal: boolean
  marketingPrefs3PartiesExternal: boolean
  memberNameConfirmed: boolean
  addresses: Address[]
  hasMfa: boolean
  marketingPrefsPostal: boolean
  lastLoginTime: string
}
